/*
 * Auma — «Hana», l'assistente del sito (snippets/auma-hana.liquid).
 *
 * Risponde da sola, nel browser, senza API: una base di risposte scritte a mano sui
 * fatti del negozio (spedizione, omaggio, codici, codice fiscale, resi, ritiro) e la
 * ricerca nel catalogo vero, letto da /collections/disponibili?view=hana-json. Il
 * bottone WhatsApp compare solo quando serve una persona.
 *
 * I fatti qui dentro devono restare veri. Se cambia una regola del negozio (soglia
 * della spedizione, soglia dell'omaggio, codice di benvenuto, policy dei resi) va
 * cambiata anche qui: Hana non lo legge da nessuna parte. Hana non da' consigli medici
 * e non promette effetti dei prodotti: per quello rimanda alla scheda, all'INCI e alle guide.
 */
(function () {
  'use strict';

  var root = document.getElementById('hana');
  if (!root) return;

  var PHONE = (root.dataset.phone || '').replace(/\D/g, '');
  var PREFILL = root.dataset.prefill || 'Ciao Auma!';
  var AVATAR = root.dataset.avatar || '';
  if (!PHONE) return;

  function waLink(text) {
    return 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(text || PREFILL);
  }

  var fab = document.getElementById('hana-fab');

  // Shopify mette in basso a destra il badge di hCaptcha (protezione dei moduli), proprio
  // dove sta Hana, e lo inserisce quando vuole lui: Hana si alza sopra il badge appena
  // compare, invece di farsi coprire.
  function posiziona() {
    var b = document.getElementById('shop-hcaptcha-badge-container');
    var alza = 0;
    if (b) {
      var r = b.getBoundingClientRect();
      if (r.height && r.left < window.innerWidth && getComputedStyle(b).display !== 'none') alza = Math.round(window.innerHeight - r.top + 12);
    }
    root.style.setProperty('--hana-alza', alza + 'px');
    if (typeof misuraPannello === 'function') misuraPannello();
  }
  posiziona();
  window.addEventListener('resize', posiziona);
  if ('MutationObserver' in window) {
    new MutationObserver(posiziona).observe(document.body, { childList: true });
  }
  [800, 2500, 6000].forEach(function (ms) { window.setTimeout(posiziona, ms); });

  // Sito inglese: niente chat (le risposte sono in italiano), il bottone apre WhatsApp.
  if (root.dataset.chat !== '1') {
    fab.addEventListener('click', function () { window.open(waLink('Hi Auma K-Beauty!'), '_blank', 'noopener'); });
    return;
  }

  var panel = document.getElementById('hana-panel');
  var body = document.getElementById('hana-body');
  var quick = document.getElementById('hana-quick');
  var form = document.getElementById('hana-form');
  var input = document.getElementById('hana-input');
  var cta = document.getElementById('hana-cta');
  var closeBtn = root.querySelector('.hana__close');

  /* ============ Le risposte ============
     [testo](/percorso) diventa un link: solo percorsi interni del sito. */
  var A = {
    spedizione: "Spediamo in tutta Italia con BRT 📦 Prepariamo il pacco entro 24–36 ore lavorative e arriva in 2–4 giorni lavorativi dall'ordine.\nLa spedizione è gratis da 35 € in su; sotto quella cifra il costo lo vedi nel carrello, prima di pagare. Appena parte ti arriva il codice per seguirla.",
    ritiro: "Puoi anche ritirare gratis a Roma, in Via Gian Leonardo Ceruso 18, dal lunedì al venerdì dalle 9 alle 18 🌿\nÈ un ufficio, non un negozio: si viene solo a ritirare un ordine fatto online. Scegli il ritiro al check-out e aspetta la nostra email «è pronto» prima di passare (di solito entro 24–36 ore lavorative). Porta il numero d'ordine.",
    omaggio: "Con un ordine da 29 € in su ti regaliamo una maschera in tessuto 🎁 Entra nel carrello da sola, a 0 €, e resta anche se usi un codice sconto. La scegliamo noi fra quelle disponibili.",
    codici: "Se è il tuo primo ordine hai il 10% con il codice CIAOAUMA, sui prodotti che non sono già in offerta 💙\nI prodotti già scontati hanno il prezzo barrato e non sommano altri codici: trovi tutte le [offerte qui](/collections/saldi). E la maschera in omaggio sopra i 29 € arriva comunque.",
    fiscale: "Per comprare il codice fiscale non serve 🌿 Se ti serve la fattura, nel [carrello](/cart) spunta «Mi serve la fattura» e inserisci il codice fiscale; per un'azienda servono ragione sociale, partita IVA e codice SDI o PEC.\nSe paghi al volo con Shop, PayPal o Google Pay dalla scheda prodotto, il carrello lo salti: scrivici dopo l'ordine e ti mandiamo la fattura.",
    pagamenti: "Al check-out puoi pagare con carta (Visa, Mastercard, Amex, Maestro), Apple Pay, Google Pay, PayPal o Klarna 🔒 Il pagamento è gestito da Shopify: noi i dati della carta non li vediamo mai.",
    resi: "Hai 14 giorni dalla consegna per cambiare idea, senza spiegare perché: basta scriverci a info@aumakbeauty.it. Le spese di rispedizione sono a carico tuo, salvo prodotto difettoso o sbagliato.\nUna sola eccezione, per igiene: un cosmetico con il sigillo aperto non si può restituire; se è ancora sigillato sì. Tutto il dettaglio è nella [politica di rimborso](/policies/refund-policy).",
    danno: "Mi dispiace 😔 Scrivici entro 48 ore dalla consegna con numero d'ordine e qualche foto (pacco, etichetta, prodotto) e sistemiamo noi. Non buttare l'imballo finché non abbiamo verificato.\nSe vuoi ti passo subito una persona del team su WhatsApp.",
    tempi: "Prepariamo l'ordine entro 24–36 ore lavorative e BRT consegna in 1–3 giorni lavorativi: in tutto 2–4 giorni lavorativi. Sabato, domenica e festivi non contano.",
    originali: "Sono tutti prodotti originali delle marche coreane, comprati dai loro canali e conservati in ufficio a Roma, al riparo da luce e calore 🌸 Su ogni scheda trovi l'INCI completo, così puoi controllare ogni ingrediente prima di scegliere.",
    scadenze: "Alcuni prodotti hanno la data di scadenza un po' più vicina: li mettiamo in offerta, con la data scritta chiara sotto il prezzo, così sai quanto tempo hai per usarli. Non vendiamo mai un prodotto scaduto o a meno di un mese dalla data.\nLi trovi tutti nelle [offerte](/collections/saldi).",
    inci: "Ogni scheda prodotto riporta l'INCI completo, cioè la lista di tutti gli ingredienti. Se hai un'allergia o un ingrediente che vuoi evitare, controllalo lì prima di acquistare.\nSe l'INCI ti sembra arabo c'è una guida facile: [come si legge l'INCI](/blogs/news/come-si-legge-inci).",
    medico: "Su allergie, gravidanza, pelli con problemi o farmaci non posso darti un parere: è una domanda per il tuo dermatologo o medico 🙏\nQuello che posso fare è aiutarti a leggere l'INCI di un prodotto e, se vuoi, passarti una persona del team.",
    routine: "La routine coreana va dal prodotto più leggero al più ricco: detergente oleoso la sera, detergente acquoso, tonico, essenza o siero, crema, e la mattina la protezione solare ☀️\nQui è spiegata bene: [in che ordine si applicano i prodotti](/blogs/news/ordine-prodotti-skincare). Se vuoi partire subito ci sono le [routine pronte](/pages/routine-pronte).",
    tipopelle: "Non sai bene che pelle hai? C'è un [test veloce sul tipo di pelle](/pages/test-tipo-di-pelle) 🌿 Oppure dimmi tu se è secca, grassa, mista, sensibile, normale, matura o acneica e ti propongo da cosa partire.",
    vegan: "Sì, abbiamo tanti prodotti vegan 🌱 Li trovi tutti qui: [prodotti vegan](/collections/vegan-%F0%9F%8C%B1).",
    contatti: "Puoi scriverci a info@aumakbeauty.it oppure su WhatsApp, se preferisci una persona. Ma chiedimi pure qui: spedizione, codici, prodotti… di solito si risolve in due messaggi 😊",
    ordine: "Per sapere dov'è il tuo pacco usa il link di tracciamento BRT nell'email di spedizione. Se l'email non c'è o c'è qualcosa che non va, ti passo una persona del team con il tuo ordine davanti.",
    marche: "Abbiamo marche come Beauty of Joseon, Skin1004, Esfolio, Some By Mi, Axis-Y, Mixsoon, Tirtir, VT Cosmetics, Coxir, Hamel e altre ancora. Le trovi tutte, una per una, nella pagina dei [brand](/pages/brand-k-beauty). Scrivimi una marca e ti mostro cosa c'è disponibile."
  };

  var GUIDE = [
    { kws: ['niacinamid'], t: 'Niacinamide: a cosa serve', u: '/blogs/news/niacinamide-cosa-serve' },
    { kws: ['centella', 'cica'], t: 'Centella asiatica e cica', u: '/blogs/news/centella-asiatica-cica-skincare' },
    { kws: ['lumaca', 'snail', 'mucina'], t: 'La bava di lumaca', u: '/blogs/news/bava-di-lumaca-skincare' },
    { kws: ['retinol'], t: 'Retinolo per principianti', u: '/blogs/news/retinolo-principianti' },
    { kws: ['vitamina c', 'vit c'], t: 'La vitamina C', u: '/blogs/news/vitamina-c' },
    { kws: ['ialuronic'], t: "L'acido ialuronico", u: '/blogs/news/acido-ialuronico' },
    { kws: ['aha', 'bha', 'pha', 'esfolian', 'acidi'], t: 'AHA, BHA e PHA', u: '/blogs/news/aha-bha-pha-acidi-esfolianti' },
    { kws: ['doppia detersione'], t: 'La doppia detersione', u: '/blogs/news/doppia-detersione-coreana' },
    { kws: ['solare', 'spf', 'sole'], t: 'La protezione solare coreana', u: '/blogs/news/protezione-solare-coreana' },
    { kws: ['pori'], t: 'Pori dilatati', u: '/blogs/news/pori-dilatati' },
    { kws: ['barriera'], t: 'La barriera cutanea', u: '/blogs/news/barriera-cutanea' },
    { kws: ['glass skin'], t: 'La glass skin', u: '/blogs/news/glass-skin' },
    { kws: ['slugging'], t: 'Lo slugging', u: '/blogs/news/slugging' },
    { kws: ['imperfezion', 'brufol', 'acne'], t: 'Imperfezioni: cosa può fare la skincare', u: '/blogs/news/imperfezioni-cosa-puo-fare-la-skincare' },
    { kws: ['disidratat'], t: 'Pelle secca o disidratata', u: '/blogs/news/pelle-secca-o-disidratata' },
    { kws: ['uomo', 'maschile', 'mio ragazzo', 'mio marito'], t: 'La routine coreana per uomo', u: '/blogs/news/routine-uomo' },
    { kws: ['maschere in tessuto', 'sheet mask', 'maschera in tessuto'], t: 'Le maschere in tessuto', u: '/blogs/news/maschere-viso-in-tessuto-come-usarle' },
    { kws: ['essenza', 'ampoule', 'differenza'], t: 'Essenza, siero e ampoule', u: '/blogs/news/differenza-essenza-siero-ampoule' }
  ];

  var PELLI = {
    secca: { tag: 'Pelle secca', u: '/collections/pelle-secca', frase: "Per la pelle secca conta nutrire e trattenere l'idratazione: creme ricche, essenze e sieri idratanti." },
    grassa: { tag: 'Pelle grassa', u: '/collections/pelle-grassa', frase: 'Per la pelle grassa servono texture leggere, una detersione delicata e niente che appesantisca.' },
    mista: { tag: 'Pelle mista', u: '/collections/pelle-mista', frase: 'La pelle mista vuole equilibrio: leggera dove lucida, più nutriente dove tira.' },
    sensibile: { tag: 'Pelle sensibile', u: '/collections/pelle-sensibile', frase: 'Per la pelle sensibile meglio formule delicate e lenitive, e introdurre un prodotto nuovo alla volta.' },
    normale: { tag: 'Pelle normale', u: '/collections/pelle-normale', frase: 'Con la pelle normale puoi divertirti: basta una routine semplice e costante.' },
    matura: { tag: 'Pelle matura', u: '/collections/pelle-matura', frase: 'Per la pelle matura contano idratazione profonda, elasticità e protezione solare ogni giorno.' },
    acneica: { tag: 'Pelle acneica', u: '/collections/pelle-acneica', frase: 'Per la pelle con imperfezioni servono prodotti leggeri e una detersione delicata, senza aggredire.' }
  };

  var ROUTES = [
    { id: '__umano__', kws: ['operator', 'una persona', 'persona vera', 'persona reale', 'parlare con qualcuno', 'essere umano', 'qualcuno del team', 'parlare con voi', 'telefonare', 'chiamarvi', 'numero di telefono', 'whatsapp'] },
    { id: '__problema__', kws: ['reclamo', 'arrabbiat', 'deluso', 'delusa', 'truffa', 'non e arrivato', 'non mi e arrivato', 'mai arrivato', 'pacco perso', 'smarrit', 'sbagliato', 'mancante', 'manca un', 'rimborso non', 'pessim'] },
    { id: 'medico', kws: ['allergi', 'gravidanz', 'incinta', 'allatt', 'dermatit', 'eczema', 'psoriasi', 'rosacea', 'farmac', 'medico', 'dermatolog', 'irritazione forte', 'reazione'] },
    { id: 'danno', kws: ['danneggiat', 'rotto', 'rotta', 'rovinat', 'aperto il pacco', 'versato', 'difettos'] },
    { id: 'resi', kws: ['reso', 'resi', 'restitu', 'recesso', 'cambiare idea', 'ripensat', 'annullare', 'rimbors', 'non mi piace'] },
    { id: 'fiscale', kws: ['codice fiscale', 'fiscale', 'fattura', 'partita iva', 'p iva', 'sdi', 'pec', 'ricevuta', 'dati per la fattura'] },
    { id: 'omaggio', kws: ['omaggio', 'regalo', 'gratis la maschera', 'maschera gratis', 'campion', 'regalate', 'sorpresa'] },
    { id: 'codici', kws: ['codice sconto', 'sconto', 'sconti', 'coupon', 'promo', 'benvenuto', 'ciaoauma', 'benvenuto10', 'glowfriday', 'black friday', 'primo ordine', 'offert', 'saldi'] },
    { id: 'ritiro', kws: ['ritir', 'passare a prendere', 'venire a prendere', 'di persona', 'negozio fisico', 'dove siete', 'indirizzo', 'sede', 'showroom', 'a roma'] },
    { id: 'ordine', kws: ['dov e il mio', 'dove il mio', 'mio ordine', 'il mio pacco', 'tracking', 'tracciament', 'traccia', 'stato dell ordine', 'numero d ordine'] },
    { id: 'spedizione', kws: ['spedi', 'consegn', 'corriere', 'brt', 'bartolini', 'costo di spedizion', 'spese di spedizion', 'arriva', 'arrivo', 'estero', 'svizzera', 'europa'] },
    { id: 'tempi', kws: ['quanto ci mette', 'quanto tempo', 'quanti giorni', 'entro quando', 'per quando'] },
    { id: 'pagamenti', kws: ['pagament', 'pagare', 'paypal', 'klarna', 'carta di credito', 'bonific', 'contrassegn', 'rate', 'satispay', 'apple pay'] },
    { id: 'scadenze', kws: ['scadenz', 'scade', 'scaduto', 'data di scadenza', 'pao'] },
    { id: 'originali', kws: ['original', 'falso', 'falsi', 'contraffatt', 'autentic', 'importat', 'dalla corea', 'conservat'] },
    { id: 'inci', kws: ['inci', 'ingredienti', 'composizione', 'formula'] },
    { id: 'routine', kws: ['routine', 'in che ordine', 'ordine dei prodotti', 'passaggi', 'step', 'come si usa', 'come si usano', 'come iniziare', 'principiant', 'da dove comincio', 'da dove inizio'] },
    { id: 'tipopelle', kws: ['tipo di pelle', 'che pelle ho', 'test della pelle', 'test pelle', 'non so che pelle'] },
    { id: 'vegan', kws: ['vegan', 'cruelty', 'testato sugli animali'] },
    { id: 'marche', kws: ['marche', 'brand', 'marchi', 'che marca'] },
    { id: 'contatti', kws: ['contatt', 'email', 'mail', 'scrivervi'] }
  ];

  var SOCIALE = {
    chi: { kws: ['chi sei', 'come ti chiami', 'sei un robot', 'sei un bot', 'sei una persona', 'sei vera', 'sei umana'], r: ["Sono Hana, l'assistente virtuale di Auma K-Beauty 🌸 Rispondo subito su prodotti, spedizione e codici. Se ti serve una persona vera, te la passo io."] },
    saluto: { kws: ['ciao', 'salve', 'buongiorno', 'buonasera', 'hey', 'ehi'], r: ['Ciao! 🌸 Dimmi pure: cerchi un prodotto, un consiglio per la tua pelle o un\'informazione sull\'ordine?', 'Ciao ciao 😊 Sono qui: cosa ti serve?'] },
    grazie: { kws: ['grazie', 'gentilissim', 'sei un tesoro'], r: ['Figurati, è un piacere 💙', 'Di nulla! Se ti serve altro, sono qui 🌸'] },
    ciao: { kws: ['arrivederci', 'a presto', 'buona giornata', 'buona serata', 'notte'], r: ['A presto! Prenditi cura di te 🌸', 'Ciao! Buona skincare 💙'] },
    ok: { kws: ['ok', 'va bene', 'perfett', 'capito', 'd accordo', 'daccordo'], r: ['Perfetto 😊 Se ti viene un dubbio, chiedi pure.'] }
  };

  /* ============ Testo ============ */
  function normalize(s) {
    return (s || '').toString().toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function hasAny(n, kws) {
    for (var i = 0; i < kws.length; i++) {
      var k = kws[i];
      // le parole corte (ok, pao, sdi...) contano solo intere, o «ok» si trova in «look»
      if (k.length <= 3 ? (' ' + n + ' ').indexOf(' ' + k + ' ') !== -1 : n.indexOf(k) !== -1) return true;
    }
    return false;
  }
  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  function pelleIn(n) {
    for (var k in PELLI) { if (n.indexOf('pelle ' + k) !== -1 || n === k) return k; }
    if (/\bimperfezion|\bbrufol|\bacne\b/.test(n)) return 'acneica';
    if (/\brughe|antiet|anti eta|elastic/.test(n)) return 'matura';
    return null;
  }

  /* ============ Catalogo ============ */
  var CAT = null, catPromise = null, CAT_KEY = 'hana_cat_v1';
  function loadCatalog() {
    if (CAT) return Promise.resolve(CAT);
    if (catPromise) return catPromise;
    try { var c = sessionStorage.getItem(CAT_KEY); if (c) { CAT = JSON.parse(c); return Promise.resolve(CAT); } } catch (e) {}
    // Senza intestazione Accept: con «application/json» Shopify ignora ?view= e risponde
    // con il suo JSON di collezione, che non ha i prodotti (verificato il 2026-10-22).
    catPromise = fetch('/collections/disponibili?view=hana-json', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.p || !d.p.length) return null;
        CAT = d;
        try { sessionStorage.setItem(CAT_KEY, JSON.stringify(d)); } catch (e) {}
        return CAT;
      })
      .catch(function () { return null; });
    return catPromise;
  }

  // Come parla una cliente → come si chiama a catalogo (il tipo prodotto di Shopify).
  var SIN = {
    detergente: 'detergente', struccante: 'olio detergente', 'olio detergente': 'olio detergente', schiuma: 'schiuma detergente',
    crema: 'crema', idratante: 'crema', tonico: 'tonico', toner: 'tonico', siero: 'siero', serum: 'siero',
    ampolla: 'ampoule', ampoule: 'ampoule', essenza: 'essence', essence: 'essence', maschera: 'maschera', maschere: 'maschera',
    mask: 'maschera', patch: 'patch', occhi: 'occhi', contorno: 'occhi', solare: 'solare', spf: 'solare', sole: 'solare',
    peeling: 'peeling', esfoliante: 'peeling', scrub: 'peeling', labbra: 'labbra', rossetto: 'labbra', tinta: 'labbra',
    fondotinta: 'fondotinta', cushion: 'fondotinta', mani: 'mani', piedi: 'piedi', capelli: 'capelli', pad: 'pad', mist: 'mist'
  };
  var STOP = { il: 1, lo: 1, la: 1, gli: 1, le: 1, un: 1, una: 1, uno: 1, di: 1, del: 1, della: 1, per: 1, con: 1, che: 1, mi: 1, ci: 1, e: 1, a: 1, da: 1, in: 1, su: 1, avete: 1, vorrei: 1, cerco: 1, cosa: 1, quale: 1, quali: 1, consigli: 1, consigliate: 1, consigliami: 1, mio: 1, mia: 1, pelle: 1, prodotto: 1, prodotti: 1, buono: 1, buona: 1, qualcosa: 1, viso: 1 };

  function tokens(n) {
    var out = [];
    Object.keys(SIN).forEach(function (k) { if (k.indexOf(' ') > -1 && n.indexOf(k) > -1) { out.push(SIN[k]); n = n.split(k).join(' '); } });
    n.split(' ').forEach(function (w) {
      if (w.length < 3 || STOP[w]) return;
      out.push(SIN[w] || w);
    });
    return out;
  }

  function cerca(text, pelle, limite) {
    if (!CAT) return [];
    var tk = tokens(normalize(text));
    var tagPelle = pelle ? PELLI[pelle].tag : null;
    var res = [];
    CAT.p.forEach(function (p) {
      if (!p.a) return;
      var tit = normalize(p.t), tipo = normalize(p.ty), marca = normalize(p.v);
      var s = 0;
      tk.forEach(function (w) {
        // «crema» deve trovare prima una «Crema viso» che una «Crema maschera viso»
        if (tipo.indexOf(w) === 0) s += 10;
        else if (tipo.indexOf(w) > -1) s += 6;
        else if (marca.indexOf(w) > -1) s += 7;
        else if (tit.indexOf(w) > -1) s += 5;
      });
      if (tagPelle) {
        if ((p.tg || []).indexOf(tagPelle) === -1) return;
        s += 4;
      }
      if (!s) return;
      res.push({ p: p, s: s });
    });
    res.sort(function (a, b) { return b.s - a.s || a.p.pr - b.p.pr; });
    return res.slice(0, limite || 3).map(function (x) { return x.p; });
  }

  function euro(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  /* ============ Disegno ============ */
  function scrollDown() { body.scrollTop = body.scrollHeight; }

  // Solo testo e link interni: niente innerHTML con contenuti che non sono nostri.
  function ricco(el, text) {
    var re = /\[([^\]]+)\]\((\/[^)\s]*)\)/g, last = 0, m;
    while ((m = re.exec(text))) {
      if (m.index > last) el.appendChild(document.createTextNode(text.slice(last, m.index)));
      var a = document.createElement('a');
      a.href = m[2];
      a.textContent = m[1];
      el.appendChild(a);
      last = re.lastIndex;
    }
    if (last < text.length) el.appendChild(document.createTextNode(text.slice(last)));
  }

  function addMsg(text, chi) {
    var w = document.createElement('div');
    w.className = 'hana__msg hana__msg--' + chi;
    if (chi === 'bot') {
      var av = document.createElement('span');
      av.className = 'hana__msg-av';
      if (AVATAR) av.style.backgroundImage = 'url("' + AVATAR + '")';
      w.appendChild(av);
    }
    var b = document.createElement('div');
    b.className = 'hana__bubble';
    if (chi === 'bot') ricco(b, text); else b.textContent = text;
    w.appendChild(b);
    body.insertBefore(w, quick);
    scrollDown();
  }

  function scrive() {
    var w = document.createElement('div');
    w.className = 'hana__msg hana__msg--bot';
    var av = document.createElement('span');
    av.className = 'hana__msg-av';
    if (AVATAR) av.style.backgroundImage = 'url("' + AVATAR + '")';
    w.appendChild(av);
    var b = document.createElement('div');
    b.className = 'hana__bubble';
    b.innerHTML = '<span class="hana__typing"><span></span><span></span><span></span></span>';
    w.appendChild(b);
    body.insertBefore(w, quick);
    scrollDown();
    return w;
  }

  function cards(lista) {
    if (!lista || !lista.length) return;
    var w = document.createElement('div');
    w.className = 'hana__cards';
    lista.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'hana__card';
      a.href = p.u;
      var im = document.createElement('span');
      im.className = 'hana__card-img';
      if (p.i) im.style.backgroundImage = 'url("' + p.i + '")';
      a.appendChild(im);
      var bd = document.createElement('span');
      bd.className = 'hana__card-body';
      var br = document.createElement('span'); br.className = 'hana__card-brand'; br.textContent = p.v;
      var nm = document.createElement('span'); nm.className = 'hana__card-name'; nm.textContent = p.t;
      var pz = document.createElement('span'); pz.className = 'hana__card-price';
      if (p.ca && p.ca > p.pr) { var s = document.createElement('s'); s.textContent = euro(p.ca); pz.appendChild(s); }
      pz.appendChild(document.createTextNode(euro(p.pr)));
      bd.appendChild(br); bd.appendChild(nm); bd.appendChild(pz);
      a.appendChild(bd);
      var go = document.createElement('span'); go.className = 'hana__card-go'; go.textContent = 'Vedi';
      a.appendChild(go);
      w.appendChild(a);
    });
    body.insertBefore(w, quick);
    scrollDown();
  }

  function chips(items) {
    quick.innerHTML = '';
    items.forEach(function (it) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hana__chip';
      b.textContent = it.label;
      b.addEventListener('click', it.run);
      quick.appendChild(b);
    });
    scrollDown();
  }

  function chipsBase() {
    chips([
      { label: 'Consigliami per la mia pelle', run: function () { addMsg('Consigliami per la mia pelle', 'user'); chiediPelle(); } },
      { label: 'Spedizione e omaggio', run: function () { domanda('Spedizione e omaggio?', A.spedizione + '\n\n' + A.omaggio); } },
      { label: 'Codici sconto', run: function () { domanda('Avete codici sconto?', A.codici); } },
      { label: 'Resi', run: function () { domanda('Come funzionano i resi?', A.resi); } },
      { label: 'Parla con una persona', run: function () { addMsg('Vorrei parlare con una persona', 'user'); persona('Ciao Auma! Vorrei parlare con una persona del team.'); } }
    ]);
  }

  function risposta(text, dopo) {
    var t = scrive();
    quick.innerHTML = '';
    var ritardo = Math.max(500, Math.min(1400, 320 + text.length * 7));
    window.setTimeout(function () {
      t.remove();
      addMsg(text, 'bot');
      if (dopo) dopo(); else chipsBase();
      var ae = document.activeElement;
      if (aperta && (!ae || ae === document.body)) {
        var c = quick.querySelector('.hana__chip');
        if (c) c.focus();
      }
    }, ritardo);
  }

  function domanda(q, a) { capito(); addMsg(q, 'user'); setWA(false); risposta(a); }

  /* ============ WhatsApp ============ */
  function setWA(on, text) {
    if (on) { cta.setAttribute('href', waLink(text || PREFILL)); root.classList.add('hana--wa'); }
    else root.classList.remove('hana--wa');
  }

  function persona(text) {
    mancati = 0;
    setWA(true, text);
    risposta('Certo 💙 Tocca il pulsante verde qui sotto e continui su WhatsApp con una persona del team: il messaggio è già scritto, devi solo inviarlo.\nIntanto, se vuoi, chiedi pure a me.');
  }

  /* ============ Pelle ============ */
  function chiediPelle() {
    capito();
    setWA(false);
    risposta("Che pelle hai? Se non lo sai, c'è il [test sul tipo di pelle](/pages/test-tipo-di-pelle) 🌿", function () {
      chips(Object.keys(PELLI).map(function (k) {
        return { label: 'Pelle ' + k, run: function () { addMsg('Ho la pelle ' + k, 'user'); consigliaPelle(k, ''); } };
      }));
    });
  }

  function consigliaPelle(k, text) {
    capito();
    setWA(false);
    loadCatalog().then(function () {
      var lista = cerca(text || 'crema siero tonico detergente', k, 3);
      if (!lista.length && CAT) lista = CAT.p.filter(function (p) { return p.a && (p.tg || []).indexOf(PELLI[k].tag) > -1; }).slice(0, 3);
      var msg = PELLI[k].frase + '\nEcco da dove partirei, fra i prodotti disponibili adesso. Tutti quelli adatti sono [qui](' + PELLI[k].u + ').';
      risposta(msg, function () {
        cards(lista);
        chips([
          { label: 'In che ordine si usano?', run: function () { domanda('In che ordine si usano?', A.routine); } },
          { label: 'Spedizione e omaggio', run: function () { domanda('Spedizione e omaggio?', A.spedizione + '\n\n' + A.omaggio); } },
          { label: 'Altro tipo di pelle', run: function () { addMsg('Un altro tipo di pelle', 'user'); chiediPelle(); } }
        ]);
      });
    });
  }

  /* ============ Instradamento ============ */
  var mancati = 0;
  function capito() { mancati = 0; }

  function rispondi(text) {
    var n = normalize(text);
    if (!n) return;
    if (hasAny(n, SOCIALE.chi.kws)) { capito(); risposta(pick(SOCIALE.chi.r)); return; }
    if (hasAny(n, ROUTES[0].kws)) { persona(text); return; }
    if (hasAny(n, ROUTES[1].kws)) {
      capito();
      setWA(true, text);
      risposta("Mi dispiace, sistemiamo subito 😔 Tocca il pulsante verde qui sotto: su WhatsApp ti risponde una persona del team, con il tuo ordine davanti.");
      return;
    }
    for (var i = 2; i < ROUTES.length; i++) {
      if (hasAny(n, ROUTES[i].kws)) {
        var id = ROUTES[i].id;
        capito();
        setWA(id === 'medico' || id === 'danno' ? true : false, text);
        risposta(A[id]);
        return;
      }
    }

    // Guide sugli ingredienti, con i prodotti che li contengono nel nome.
    for (var g = 0; g < GUIDE.length; g++) {
      if (hasAny(n, GUIDE[g].kws)) {
        var guida = GUIDE[g];
        capito();
        setWA(false);
        loadCatalog().then(function () {
          var lista = cerca(text, pelleIn(n), 3);
          risposta('Ne parliamo bene qui: [' + guida.t + '](' + guida.u + ').' + (lista.length ? '\nE questi sono alcuni prodotti disponibili che fanno al caso tuo 👇' : ''), function () {
            cards(lista);
            chipsBase();
          });
        });
        return;
      }
    }

    var pelle = pelleIn(n);
    loadCatalog().then(function () {
      var lista = cerca(text, pelle, 3);
      if (lista.length) {
        capito();
        setWA(false);
        var top = lista[0];
        var msg = lista.length === 1
          ? top.v + ' ' + top.t + ': ' + euro(top.pr) + '. Te lo apro qui sotto 👇'
          : 'Ecco cosa ho per te, disponibile adesso 👇' + (pelle ? '\nTutti quelli per la pelle ' + pelle + ' sono [qui](' + PELLI[pelle].u + ').' : '');
        risposta(msg, function () { cards(lista); chipsBase(); });
        return;
      }
      if (pelle) { consigliaPelle(pelle, ''); return; }
      if (hasAny(n, SOCIALE.saluto.kws)) { capito(); risposta(pick(SOCIALE.saluto.r)); return; }
      if (hasAny(n, SOCIALE.grazie.kws)) { capito(); risposta(pick(SOCIALE.grazie.r)); return; }
      if (hasAny(n, SOCIALE.ciao.kws)) { capito(); risposta(pick(SOCIALE.ciao.r)); return; }
      if (hasAny(n, SOCIALE.ok.kws)) { capito(); risposta(pick(SOCIALE.ok.r)); return; }
      nonCapito(text);
    });
  }

  // Al primo buco Hana riprova; al secondo di fila passa una persona.
  function nonCapito(text) {
    mancati++;
    if (mancati >= 2) {
      mancati = 0;
      setWA(true, text);
      risposta('Su questa non sono sicura, e non voglio farti perdere tempo: ti passo una persona del team 💙 Tocca il pulsante verde qui sotto, il messaggio è già pronto.');
      return;
    }
    setWA(false);
    risposta('Questa me la sono persa 🙈 Prova a scrivermi il tipo di prodotto (crema, siero, maschera…), una marca, il tuo tipo di pelle, oppure scegli qui sotto.');
  }

  /* ============ Apertura ============ */
  var aperta = false, pronta = false;

  // Il pannello si apre sopra il bottone: va tenuto sotto la testata fissa del sito,
  // che su iPhone (barra di Safari, bottone alzato sopra hCaptcha) gli rubava la cima.
  function misuraPannello() {
    if (!panel || panel.hidden) return;
    var testata = document.getElementById('header-component');
    var sopra = 8;
    if (testata) {
      var r = testata.getBoundingClientRect();
      if (r.bottom > 0) sopra = Math.max(sopra, r.bottom + 8);
    }
    var sotto = fab.getBoundingClientRect().top - 14;
    panel.style.maxHeight = Math.max(180, Math.min(580, sotto - sopra)) + 'px';
  }
  window.addEventListener('resize', misuraPannello);
  window.addEventListener('scroll', misuraPannello, { passive: true });

  function apri() {
    if (!pronta) { chipsBase(); pronta = true; }
    panel.hidden = false;
    misuraPannello();
    root.classList.add('is-open', 'is-seen');
    fab.setAttribute('aria-expanded', 'true');
    aperta = true;
    try { sessionStorage.setItem('hana_vista', '1'); } catch (e) {}
    loadCatalog();
    window.setTimeout(function () { var c = quick.querySelector('.hana__chip'); if (c) c.focus(); }, 60);
  }
  function chiudi() {
    panel.hidden = true;
    root.classList.remove('is-open');
    fab.setAttribute('aria-expanded', 'false');
    aperta = false;
    fab.focus();
  }

  fab.addEventListener('click', function () { aperta ? chiudi() : apri(); });
  if (closeBtn) closeBtn.addEventListener('click', chiudi);

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var t = (input.value || '').trim();
    if (!t) return;
    input.value = '';
    addMsg(t, 'user');
    rispondi(t);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && aperta) chiudi(); });

  // Click fuori chiude. composedPath perche' un chip si ridisegna (e si stacca) durante il suo click.
  document.addEventListener('click', function (e) {
    if (!aperta) return;
    var path = typeof e.composedPath === 'function' ? e.composedPath() : null;
    if (path && path.indexOf(root) !== -1) return;
    if (root.contains(e.target)) return;
    chiudi();
  });

  // Altri elementi del sito possono aprire Hana: <a data-hana-open>.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-hana-open]') : null;
    if (!t) return;
    e.preventDefault();
    if (!aperta) apri();
  });

  try { if (sessionStorage.getItem('hana_vista')) root.classList.add('is-seen'); } catch (e) {}
})();
